import { TextAlignment } from '../tokentypes';
import { fromConst, fromNestedArguments } from './base';
function createTextAlignment(rawData) {
  return new TextAlignment(rawData);
}
export function textAlignmentConst(rawData, tokenOptions) {
  return fromConst(createTextAlignment, rawData, tokenOptions);
}
export function textAlignmentTokenFromNestedArguments(rawData, argList, tokenOptions) {
  return fromNestedArguments(createTextAlignment, rawData, argList, tokenOptions);
}
//# sourceMappingURL=textalignments.js.map